import { ClassificationTask } from '@idea2app/ai-work-order-service';
import { Icon } from 'idea-react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { Column, RestTable } from 'mobx-restful-table';
import { Component } from 'react';
import { Badge, Button, Card } from 'react-bootstrap';
import { RouteComponentProps, withRouter } from 'react-router-class-tools';

import classificationTaskStore, {
    AICapabilityLabels,
    TaskStatusColors,
    TaskStatusLabels
} from '../model/ClassificationTask';
import { i18n, I18nKey, t } from '../model/Translation';

const TaskName = ({ t }: typeof i18n) => ({
    deduplication: t('duplicate_work_order_extraction')
});

@withRouter
@observer
export class TaskCreatorPage extends Component<
    RouteComponentProps<{ type: string }>
> {
    @computed
    get columns(): Column<ClassificationTask>[] {
        return [
            {
                key: 'id',
                type: 'number',
                renderHead: t('task_id')
            },
            {
                key: 'name',
                renderHead: t('task_name')
            },
            {
                key: 'aiCapabilities',
                renderHead: t('ai_capabilities'),
                renderBody: ({ aiCapabilities }) =>
                    aiCapabilities?.map(cap => (
                        <Badge key={cap} bg="info" className="me-1">
                            {t(AICapabilityLabels[cap] as I18nKey)}
                        </Badge>
                    ))
            },
            {
                key: 'status',
                renderHead: t('task_status'),
                renderBody: ({ status }) => (
                    <Badge bg={TaskStatusColors[status]}>
                        {t(TaskStatusLabels[status] as I18nKey)}
                    </Badge>
                )
            },
            {
                key: 'totalWorkOrders',
                type: 'number',
                renderHead: t('total_work_orders'),
                renderBody: ({ totalWorkOrders }) => totalWorkOrders || 0
            },
            {
                key: 'processedWorkOrders',
                type: 'number',
                renderHead: t('processed_work_orders'),
                renderBody: ({ processedWorkOrders }) =>
                    processedWorkOrders || 0
            }
        ];
    }

    render() {
        const { type } = this.props.match.params;
        const typeName = TaskName(i18n)[type];

        return (
            <>
                <Card className="m-3" body>
                    <hgroup className="p-4 d-flex align-items-center gap-4">
                        <Icon
                            name="compass"
                            className="text-primary"
                            size={3}
                        />
                        <div>
                            <h2 className="fs-3">
                                {t('create')}
                                {typeName}:{' '}
                                {t('please_select_classification_result')}
                            </h2>
                            <p className="text-primary m-0">
                                {t('select_classification_task_hint')}
                                {typeName}
                                {t('analysis_suffix')}
                            </p>
                        </div>
                    </hgroup>

                    <RestTable
                        columns={this.columns}
                        store={classificationTaskStore}
                        translator={i18n}
                        striped
                        hover
                    />
                </Card>
                <footer className="bg-white py-4 px-5 d-flex align-items-center gap-2">
                    <Icon name="clock" size={2} />

                    <span className="flex-fill">
                        {t('estimated_analysis_time_15_30')}
                    </span>

                    <Button variant="primary" size="lg">
                        <Icon name="play-fill" className="me-2" />
                        {t('start_analysis_button')}
                    </Button>
                </footer>
            </>
        );
    }
}
